<template>
  <HeaderContent />
  <router-view />
  <a href="https://lin.ee/8je37Jo" className=" fixed right-0 top-[30%] w-[3.5rem] z-[100]" target="_blank">
    <img src="https://static-jp.theckb.com/static-asset/sellerstation/line_icon.png" alt="" />
  </a>
</template>
<script lang="ts" setup>
import HeaderContent from '@/components/layout/HeaderContent.vue';
</script>
